import { SttAlerta } from '@stt-componentes/core';
import { useSignals } from '@preact/signals-react/runtime';

/* @useSignals */
import { alertaMensagem } from '../signals/alerta';

function Alerta() {
    useSignals();
    const alerta = alertaMensagem.value;
    const handleOnClose = () => {
        alertaMensagem.value = { ...alerta, open: false };
    };

    if (!alerta.open) {
        return null;
    }

    return (
        <SttAlerta
            open={alerta.open}
            title={alerta.title}
            message={alerta.message}
            type={alerta.type}
            options={[
                {
                    title: 'Ok',
                    onClick: handleOnClose,
                },
            ]}
            onClose={handleOnClose}
        />
    );
}

export default Alerta;
